import React from 'react';
import Navigation from './Navigation';
import styles from './index.module.css';

const items = [
    {
        id: 'hello',
        label: 'Hello',
        title: 'Hello',
        to: '/'
    },
    {
        id: 'github',
        label: 'GitHub',
        title: 'GitHub',
        icon: 'github',
        iconOnly: true,
        to: 'https://github.com/malte-wessel'
    },
    {
        id: 'linkedin',
        label: 'LinkedIn',
        title: 'LinkedIn',
        icon: 'linkedin',
        iconOnly: true,
        to: 'https://www.linkedin.com/in/malte-wessel'
    },
    {
        id: 'twitter',
        label: 'Twitter',
        title: 'Twitter',
        icon: 'twitter',
        iconOnly: true,
        to: 'https://twitter.com/drbreak'
    }
];

const Header = () => (
    <header className={styles.header}>
        <div className={styles.logo}>Malte Wessel</div>
        <Navigation items={items} className={styles.nav} />
    </header>
);

export default Header;
